import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {logoutUser, setUser} from "../../redux/actions/user";
import {CheckUserLoginFromApi} from "../../redux/utils/authUtils";
import {API_TOKEN} from "../../redux/actions/user";
//component
import PageLoader from "./../../components/loader/PageLoader"
import PrivateRoute from "../misc/PrivateRoute";
import PublicRoute from "../misc/PublicRoute";
import Header from "../../components/header/Header";
import FooterPage from "../../components/footer/Footer";
import Login from "../auth/Login";
import Register from "../auth/Register";
//public page
import Home from "../home/Home";
import Products from "../products/Products";
import ProductDetail from "../products/ProductDetail";
import HowItWorks from "../faq/faq";
import Community from "../community/Community";
import ContactUs from "../contact/ContactUs";
import About from "../about/About";
import NotFound from "../misc/NotFound";
// User panel
import UsersPage from "../user/UsersPage";
import UsersProfile from "../user/UsersProfile";
//other public page
import RulesOfUse from "../pages/RulesOfUse";
import HotelRules from "../pages/HotelRules";
import Business from "../pages/Business";
import MerchantPartners from "../pages/MerchantPartners";
import Careers from "../pages/Careers";
import Licences from "../pages/Licences";
import TermsOfSale from "../pages/TermsOfSale";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfUse from "../pages/TermsOfUse";
import Sitemap from "../pages/Sitemap";
import MerchantList from "../merchants/MerchantList";
import MerchantListByCat from "../merchants/MerchantListByCat";
import MerchantItem from "../merchants/MerchantItem";
import HelpItem from "../faq/HelpItem";

import "./app.css";
import UserCartsList from "../products/UserCartsList";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apiToken:"",
            is_authenticated:false,
            isLoading: true,
        }
    }

    async componentDidMount() {
        const {store} = this.props;
        await CheckUserLoginFromApi(store);
        let apiToken = await localStorage.getItem(API_TOKEN);
        let is_authenticated = false;
        // console.log(apiToken);
        if (apiToken === null || apiToken ===""){
            console.log("token is invalid");
            is_authenticated = false;
            this.props.logoutUser();
        }else {
            if ((this.props.user.firstName === undefined) || (this.props.user.firstName === null)) {
                console.log("user not valid");
                is_authenticated = false;
                this.props.logoutUser();
            } else {
                console.log("token available");
                is_authenticated = true;
            }
        }
        this.setState({isLoading: false,is_authenticated})
    }

    render() {
        const {is_authenticated} = this.state;

        return (
            this.state.isLoading ?
                <PageLoader type="bubbles" color="#f6581d" />
                :
                <Router forceRefresh={true}  basename='/'>
                    <div>
                        <div className="">
                            <Header isAuthenticated={is_authenticated} />
                            <div className='appContent'>
                                <Switch>
                                  <Route exact path="/" component={Home} />
                                  <Route path="/products" component={Products} />
                                  <Route path="/how-it-works" component={HowItWorks} />
                                  <Route path="/community" component={Community} />
                                  <Route path="/contact-us" component={ContactUs} />

                                  <Route path="/product/:id" component={ProductDetail} />

                                  <Route path="/merchantList" component={MerchantList} />
                                  <Route path="/merchants/:id" component={MerchantListByCat} />
                                  {/*<Route path="/merchant/:slug" component={MerchantItem} />*/}
                                  <Route path="/merchant/:id" component={MerchantItem} />

                                  <Route path="/faq/:id" component={HelpItem} />

                                  {/*//public Routes*/}
                                  <PublicRoute path="/register" isAuthenticated={is_authenticated} component={Register}/>
                                  <PublicRoute path="/login" isAuthenticated={is_authenticated} component={Login}/>
                                  {/*//Private Routes*/}
                                  <PrivateRoute path="/users" isAuthenticated={is_authenticated} component={UsersPage}/>
                                  <PrivateRoute path="/profile" isAuthenticated={is_authenticated} component={UsersProfile}/>
                                  <PrivateRoute path="/my-orders" isAuthenticated={is_authenticated} component={UserCartsList}/>
                                  <PrivateRoute path="/new-transaction" isAuthenticated={is_authenticated} component={UsersPage}/>
                                  <PrivateRoute path="/refer-to-friend" isAuthenticated={is_authenticated} component={UsersPage}/>
                                  {/*Contents*/}
                                  <Route path="/rules-of-use" component={RulesOfUse} />
                                  <Route path="/hotel-rules" component={HotelRules} />
                                  <Route path="/business" component={Business} />
                                  <Route path="/merchant-partners" component={MerchantPartners} />
                                  <Route path="/careers" component={Careers} />
                                  <Route path="/licences" component={Licences} />
                                  <Route path="/terms-of-sale" component={TermsOfSale} />
                                  <Route path="/terms-of-use" component={TermsOfUse} />
                                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                                  <Route path="/about" component={About} />
                                  <Route path="/sitemap" component={Sitemap} />

                                  <Route component={NotFound} />
                                </Switch>
                            </div>
                        </div>
                        <FooterPage  />
                    </div>
                </Router>
            );
          }
    }


const mapStateToProps = (state) => {
    return {
        user : state.user,
        categories: state.categories,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        },
        logoutUser : () =>{
            dispatch(logoutUser())
        },
    }
};
export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/app/App.js